import React from 'react';

interface SearchResultsSkeletonProps {
  /**
   * Number of skeleton items to show
   */
  itemCount?: number;

  /**
   * Whether to show dividers between items
   */
  withDividers?: boolean;

  /**
   * Whether this skeleton is for a search with no results
   */
  isEmpty?: boolean;

  /**
   * Custom empty state message
   */
  emptyMessage?: string;
}

export const SearchResultsSkeleton: React.FC<SearchResultsSkeletonProps> = ({
  itemCount = 4,
  withDividers = true,
  isEmpty = false,
  emptyMessage = 'No results found',
}) => {
  if (isEmpty) {
    return (
      <div className="p-4 text-center text-sm text-[#7A7D81]">
        {emptyMessage}
      </div>
    );
  }

  return (
    <div className={withDividers ? 'divide-y divide-[#E4E8EA]' : ''}>
      {[...Array(itemCount)].map((_, index) => (
        <div
          key={index}
          className="px-4 py-3 animate-pulse"
          style={{ animationDelay: `${index * 0.1}s` }}
        >
          <div className="h-5 w-48 bg-gray-200 rounded-md mb-1"></div>
          <div className="h-4 w-32 bg-gray-200 rounded-md"></div>
        </div>
      ))}
    </div>
  );
};
